/* HFH product-card video. Cards use the native `autoplay muted playsinline`
   attributes so the browser starts them reliably. This script then PAUSES the
   cards that scroll off-screen (and resumes them) to keep a grid of videos from
   hammering CPU/bandwidth, AND restarts the in-view cards when the tab regains
   focus (Chrome pauses all media when a tab is hidden and won't auto-resume on
   return). Respects reduced-motion and data-saver. */
(function () {
  if (window.__hfhCardVideoInit) return;
  window.__hfhCardVideoInit = true;

  function init() {
    var videos = document.querySelectorAll('video[data-card-video]');
    if (!videos.length) return;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var saveData = navigator.connection && navigator.connection.saveData;
    if (reduceMotion || saveData) {
      videos.forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); });
      return;
    }

    var inView = new Set();

    function tryPlay(v) {
      v.muted = true; // belt-and-suspenders for autoplay policies
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            inView.add(v);
            if (!document.hidden) tryPlay(v);
          } else {
            inView.delete(v);
            v.pause();
          }
        });
      }, { threshold: 0.2 });
      videos.forEach(function (v) { v.muted = true; io.observe(v); });
    }

    // Tab regained focus: Chrome paused everything while hidden — restart in-view cards.
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) inView.forEach(tryPlay);
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
